import React, {Component} from 'react';
import axios from 'axios';

import styles from "./DataBox.scss";

export default class Transit extends Component {

  constructor(props) {
    super(props)
    this.state = {
      route_data: undefined,
      route_timestamp: undefined,

      stop_data: undefined,
      stop_timestamp: undefined,

      msg: undefined
    }
  }

  componentDidMount() {
    this.getRouteTimestamp()
    this.getStopTimestamp()
  }

  uploadRouteData = () => {
    let timestamps = {
      route_timestamp: this.state.route_timestamp,
      stop_timestamp: this.state.stop_timestamp
    }
    axios
      .post('/api/admin/updateroutes', timestamps)
      .then( res => {
        this.setState({
          msg: res.data.message,
        }, () => this.getRouteTimestamp()
      );
      })
      .catch( err => {
        console.log(err)
      });
  }

  uploadStopData = () => {
    let timestamps = {
      route_timestamp: this.state.route_timestamp,
      stop_timestamp: this.state.stop_timestamp
    }
    axios
      .post('/api/admin/updatestops', timestamps)
      .then( res => {
        this.setState({
          msg: res.data.message,
        }, () => this.getStopTimestamp()
      );
        this.getStopTimestamp();
      })
      .catch( err => {
        console.log(err)
      });
  }

  getRouteTimestamp = () => {
    axios
      .post('/api/admin/getroutetimestamp')
      .then( res => {
        this.setState({
          route_timestamp: res.data.route_timestamp,
        });
      })
      .catch( err => {
        console.log(err)
      });
  }

  getStopTimestamp = () => {
    axios
      .post('/api/admin/getstoptimestamp')
      .then( res => {
        this.setState({
          stop_timestamp: res.data.stop_timestamp
        });
      })
      .catch( err => {
        console.log(err)
      });
  }

  render() {
    return (
      <div className={styles.databox}>
        <h1>Transit Data</h1>
        <p>Upload the latest transit data from
          <a href="https://opendatakingston.cityofkingston.ca/"> https://opendatakingston.cityofkingston.ca/</a>
        </p>
        <div>
          <button className="btn btn-info" onClick={this.uploadRouteData}>Upload Route Data</button>
          <p> <b>Last Update:</b> {this.state.route_timestamp}</p>

          <button className="btn btn-info" onClick={this.uploadStopData}>Upload Stop Data</button>
          <p> <b>Last Update:</b> {this.state.stop_timestamp}</p>
        </div>
        {this.state.msg &&
          <div className="alert alert-success" role="alert">{this.state.msg}</div>
        }
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Transit.js